import React, { useEffect , useState } from 'react';
import '../style/bookAppointment-style.css';
import { loadStripe } from "@stripe/stripe-js";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_KEY); 

const BookAppointmentModal = ({ onClose, client }) => {

  const [type, setType] = useState('consult');
  const [meetingType, setMeetingType] = useState(client.service_mode);
  const [checkmeetingType, setCheckMeetingType] = useState('');
  const [startTime, setStartTime] = useState('');
  const [endTime, setEndTime] = useState('');
  const [hourlyDate, setHourlyDate] = useState('');
  const [durationInDays, setDurationInDays] = useState(client.duration_in_days);
  const [dailyHours, setDailyHours] = useState(client.daily_hours);
  const [subscriptionStartTime, setSubscriptionStartTime] = useState('');
  const [subscriptionEndTime, setSubscriptionEndTime] = useState('');
  const [subscriptionDays, setSubscriptionDays] = useState();
  const [subscriptionStartDate, setSubscriptionStartDate] = useState('');
  const [subscriptionEndDate, setSubscriptionEndDate] = useState('');
  const [EndDate, setEndDate] = useState('');
  const [paymentType, setPaymentType] = useState('monthly');
  const [selectedTimes, setSelectedTimes] = useState({});
  const [workingDates, setWorkingDates] = useState([]);
  const [payloadWorkingDates, setPayloadWorkingDates] = useState([]);

  const handleStartChange = (dayIndex, selectedStart) => {
    const endTime = calculateEndTime(selectedStart, client.daily_hours);
    setSelectedTimes((prev) => ({
      ...prev,
      [dayIndex]: { start: selectedStart, end: endTime },
    }));
  };
  
  useEffect(() => {
  if (meetingType.length > 0 && !checkmeetingType) {
    setCheckMeetingType(meetingType[0]); // auto-select first option
  }
}, [meetingType, checkmeetingType]);

  const clientToken = localStorage.getItem("client_access_token");

  const navigate = useNavigate();
  
  console.log("client", client);
  console.log("checkmeetingType", checkmeetingType);

  // useEffect(() => {
  //   if (subscriptionStartDate && durationInDays) {
  //     const start = new Date(subscriptionStartDate);
  //     const end = new Date(start);
  //     end.setDate(start.getDate() + parseInt(durationInDays-1, 10));

  //     // Format to YYYY-MM-DD (ISO format)
  //     const formattedEnd = end.toISOString().split('T')[0];
  //     setSubscriptionEndDate(formattedEnd);
  //   } else {
  //     setSubscriptionEndDate('');
  //   }
  // }, [subscriptionStartDate, durationInDays]);

//   useEffect(() => {
//   if (subscriptionStartDate && durationInDays && client.provider?.worktimes) {
//     const worktimes = client.provider.worktimes;

//     // Helper: check if given date is an open day and get its working hours
//     function getWorkTimeForDay(date) {
//       const dayName = date.toLocaleDateString('en-US', { weekday: 'long' });
//       const dayObj = worktimes.find((d) => d.day === dayName);
//       if (dayObj?.checked === 'Y') {
//         return {
//           open: true,
//           opening_hours: dayObj.opening_hours,
//           closing_hours: dayObj.closing_hours,
//           dayName,
//         };
//       }
//       return { open: false, dayName };
//     }

//     let openDaysCount = 0;
//     let currentDate = new Date(subscriptionStartDate);
//     const workingDates = [];
//     const payloadWorkingDates = [];


//     for (let i = 0; i < 7; i++) {
//       const payloadWorkTime = getWorkTimeForDay(currentDate);

//       if (payloadWorkTime.open) {
//         payloadWorkingDates.push({
//           // date: currentDate.toISOString().split('T')[0],
//           // dayName: workTime.dayName,
//           opening_hours: payloadWorkTime.opening_hours,
//           closing_hours: payloadWorkTime.closing_hours,
//         });
//       }

//       // Move to next day
//       currentDate.setDate(currentDate.getDate() + 1);
//     }

//     // Loop until we count enough working days
//     while (openDaysCount < durationInDays) {
//       const workTime = getWorkTimeForDay(currentDate);

//       if (workTime.open) {
//         openDaysCount++;
//         workingDates.push({
//           date: currentDate.toISOString().split('T')[0], // simple date string
//           dayName: workTime.dayName,
//           opening_hours: workTime.opening_hours,
//           closing_hours: workTime.closing_hours,
//         });
//       }

//       if (openDaysCount < durationInDays) {
//         currentDate.setDate(currentDate.getDate() + 1);
//       }
//     }

//     // Set subscription end date formatted
//     const formattedEnd = currentDate.toISOString().split('T')[0];
//     setSubscriptionEndDate(formattedEnd);

//     // You can store or use this array of working dates elsewhere
//     setWorkingDates(workingDates); // example state for storing working days info
//     setPayloadWorkingDates(payloadWorkingDates)
//   } else {
//     setSubscriptionEndDate('');
//     setWorkingDates([]);
//     setPayloadWorkingDates([]);
//   }
// }, [subscriptionStartDate, durationInDays, client.provider?.worktimes]);

// useEffect(() => {
//   if (subscriptionStartDate && client.provider?.worktimes) {
//     const worktimes = client.provider.worktimes;

//     const getWorkTimeForDay = (date) => {
//       const dayName = date.toLocaleDateString('en-US', { weekday: 'long' });
//       const dayObj = worktimes.find((d) => d.day === dayName);
//       if (dayObj?.checked === 'Y') {
//         return {
//           open: true,
//           opening_hours: dayObj.opening_hours,
//           closing_hours: dayObj.closing_hours,
//         };
//       }
//       return { open: false };
//     };

//     const payloadWorkingDates = [];
//     const currentDate = new Date(subscriptionStartDate);

//     for (let i = 0; i < 7; i++) {
//       const workTime = getWorkTimeForDay(currentDate);

//       if (workTime.open) {
//         payloadWorkingDates.push({
//           opening_hours: workTime.opening_hours,
//           closing_hours: workTime.closing_hours,
//         });
//       }

//       currentDate.setDate(currentDate.getDate() + 1);
//     }

//     setPayloadWorkingDates(payloadWorkingDates);
//   } else {
//     setPayloadWorkingDates([]);
//   }
// }, [subscriptionStartDate, client.provider?.worktimes]);

useEffect(() => {
  if (subscriptionStartDate && client.provider?.worktimes) {
    const worktimes = client.provider.worktimes;

    const getWorkTimeForDay = (date) => {
      const dayName = date.toLocaleDateString('en-US', { weekday: 'long' });
      const dayObj = worktimes.find((d) => d.day === dayName);

      if (dayObj?.checked === 'Y') {
        return {
          day: dayName,
          opening_hours: dayObj.opening_hours || '00:00:00',
          closing_hours: dayObj.closing_hours || '00:00:00',
        };
      } else {
        // Return "closed" by default
        return {
          day: dayName,
          o_hours: '00:00:00',
          c_hours: '00:00:00',
        };
      }
    };

    const payloadWorkingDates = [];
    const currentDate = new Date(subscriptionStartDate);

    for (let i = 0; i < 7; i++) {
      const workTime = getWorkTimeForDay(currentDate);

      payloadWorkingDates.push({
        day: workTime.day,
        o_hours: workTime.opening_hours,
        c_hours: workTime.closing_hours,
      });

      currentDate.setDate(currentDate.getDate() + 1);
    }

    setPayloadWorkingDates(payloadWorkingDates);
  } else {
    setPayloadWorkingDates([]);
  }
}, [subscriptionStartDate, client.provider?.worktimes]);



useEffect(() => {
  if (subscriptionStartDate && durationInDays && client.provider?.worktimes) {
    const worktimes = client.provider.worktimes;

    const getWorkTimeForDay = (date) => {
      const dayName = date.toLocaleDateString('en-US', { weekday: 'long' });
      const dayObj = worktimes.find((d) => d.day === dayName);
      if (dayObj?.checked === 'Y') {
        return {
          open: true,
          opening_hours: dayObj.opening_hours,
          closing_hours: dayObj.closing_hours,
          dayName,
        };
      }
      return { open: false, dayName };
    };

    let openDaysCount = 0;
    let currentDate = new Date(subscriptionStartDate);
    const workingDates = [];

    while (openDaysCount < durationInDays) {
      const workTime = getWorkTimeForDay(currentDate);

      if (workTime.open) {
        workingDates.push({
          date: currentDate.toISOString().split('T')[0],
          dayName: workTime.dayName,
          opening_hours: workTime.opening_hours,
          closing_hours: workTime.closing_hours,
        });

        openDaysCount++;
      }

      currentDate.setDate(currentDate.getDate() + 1);
    }

    const lastDate = new Date(currentDate);
    lastDate.setDate(lastDate.getDate() - 1); // go back to last appointment day
    const formattedEnd = lastDate.toISOString().split('T')[0];

    setWorkingDates(workingDates);
    setSubscriptionEndDate(formattedEnd);

  } else {
    setWorkingDates([]);
    setSubscriptionEndDate('');
  }
}, [subscriptionStartDate, durationInDays, client.provider?.worktimes]);


console.log("workingDates", workingDates);
console.log("payloadWorkingDates", payloadWorkingDates);

  useEffect(() => {
    if (subscriptionStartTime && dailyHours) {
      // Parse the start time (e.g., "09:00")
      const [hours, minutes] = subscriptionStartTime.split(':').map(Number);

      // Create Date object and add hours
      const startDate = new Date();
      startDate.setHours(hours);
      startDate.setMinutes(minutes);

      // Add daily hours
      const endDate = new Date(startDate);
      endDate.setHours(endDate.getHours() + parseFloat(dailyHours));

      // Format end time as HH:MM
      const formattedEndTime = endDate
        .toTimeString()
        .split(':')
        .slice(0, 2)
        .join(':');

      setSubscriptionEndTime(formattedEndTime);
    } else {
      setEndTime('');
    }
  }, [subscriptionStartTime, dailyHours]);

  const getHourlyCharge = () => {
    if (!startTime || !endTime) return 0;
    const start = new Date(`1970-01-01T${startTime}`);
    const end = new Date(`1970-01-01T${endTime}`);
    const hours = (end - start) / 1000 / 60 / 60;
    return hours > 0 ? hours * parseFloat(client.amount_per_session) : 0;
  };
  
  const prepareBookingPayload = () => {
  let calculatedAmount = 0;
  let description = '';
  let startDate = '';
  let endDate = '';
  let start_time = '';
  let end_time = '';
  let hours = 0;
  let meetingTypeToSend = meetingType[0];
  let checkMeetingType = checkmeetingType;
  let provider_id = client.provider_id;
  let working_dates = payloadWorkingDates;
  let daily_hours_payload = client.daily_hours;
  // let provider_plan_id = 1;

  const typeCodeMap = {
    consult: 'C',
    hourly: 'H',
    subscription: 'S',
  };

  const shortType = typeCodeMap[type];

if (type === 'consult') {
  calculatedAmount = 0;
  description = 'Consult Appointment - Free';
  startDate = hourlyDate;
  endDate = hourlyDate;
  start_time = startTime + ":00";
  end_time = endTime + ":00";
}

  if (type === 'hourly') {
    const start = new Date(`1970-01-01T${startTime}`);
    const end = new Date(`1970-01-01T${endTime}`);
    hours = (end - start) / 1000 / 60 / 60;

    if (hours <= 0) {
      alert("End time must be after start time.");
      return null;
    }

    startDate = hourlyDate;
    endDate = hourlyDate;
    start_time = startTime + ":00"; // format to match 14:00:00
    end_time = endTime + ":00";
    calculatedAmount = hours * parseFloat(client.amount_per_session);
    description = `Hourly Appointment - ${hours} hour(s) at $${client.amount_per_session}/hour`;
  }

  if (type === 'subscription') {
    if (!paymentType) {
      alert("Please select payment type: Weekly or Monthly");
      return null;
    }

    const subStart = new Date(`1970-01-01T${subscriptionStartTime}`);
    const subEnd = new Date(`1970-01-01T${subscriptionEndTime}`);
    const subHours = (subEnd - subStart) / 1000 / 60 / 60;

    hours = subscriptionDays * subHours;

    startDate = subscriptionStartDate;
    endDate = subscriptionEndDate; // Optional: you can calculate based on days if needed
    start_time = subscriptionStartTime + ":00";
    end_time = subscriptionEndTime + ":00";

    if (paymentType === 'monthly') {
      calculatedAmount = parseFloat(client.amount);
      description = `Subscription - Monthly payment`;
    } else if (paymentType === 'weekly') {
      calculatedAmount = parseFloat(client.charge_per_week);
      description = `Subscription - Weekly payment`;
    }
// console.log("daily hours", daily_hours_payload);
    // working_dates = payloadWorkingDates.map((item, index) => {
    //   const selected = selectedTimes[index];
    //   console.log("selected", selected);
    //   return {
    //     day: item.day,
    //     o_hours: selected?.start ? selected.start + ':00' : item.o_hours,
    //     c_hours: selected?.end ? selected.end + ':00' : item.c_hours,
    //   };
    // });

// Convert daily_hours_payload (e.g. "02:00:00") into total minutes
// 1. Convert daily hours payload into minutes
// 1. Convert daily hours payload into minutes
const [dhH, dhM, dhS] = daily_hours_payload.split(":").map(Number);
const dailyMinutes = dhH * 60 + dhM + (dhS ? dhS / 60 : 0);

// 2. Count working days that have hours
const daysWithHours = payloadWorkingDates.filter(
  (item) => item.o_hours && item.c_hours
);
const requiredCount = daysWithHours.length;

// 3. Normalize selectedTimes into an array
const selectedArray = Array.isArray(selectedTimes)
  ? selectedTimes
  : Object.values(selectedTimes || {});

// 4. Pick only valid selections
const selectedValid = selectedArray.filter(
  (sel) => sel && sel.start && sel.end
);
const selectedCount = selectedValid.length;

// 👉 Step A: Check if counts match
if (selectedCount !== requiredCount) {
  toast.error(
    `You must select time slots for all ${requiredCount} working days. Selected only ${selectedCount}.`
  );
  return;
}

// 👉 Step B: Validate each selection duration
let isValid = true;

selectedValid.forEach((sel, idx) => {
  const [sH, sM] = sel.start.split(":").map(Number);
  const [eH, eM] = sel.end.split(":").map(Number);

  const startMinutes = sH * 60 + sM;
  const endMinutes = eH * 60 + eM;
  const diffMinutes = endMinutes - startMinutes;

  console.log(
    `📅 Day: ${daysWithHours[idx].day} | Start: ${sel.start} | End: ${sel.end} | Diff: ${diffMinutes} mins`
  );

  if (diffMinutes > dailyMinutes) {
    toast.error(
      `${daysWithHours[idx].day}: Selected hours exceed daily limit of ${
        dailyMinutes / 60
      } hours!`
    );
    isValid = false;
  }
});

if (!isValid) return;

// ✅ If all valid → now build working_dates payload
    working_dates = payloadWorkingDates.map((item, index) => {
      const selected = selectedTimes[index];
      console.log("selected", selected);
      return {
        day: item.day,
        o_hours: selected?.start ? selected.start + ':00' : item.o_hours,
        c_hours: selected?.end ? selected.end + ':00' : item.c_hours,
      };
    });

console.log("🚀 Final working_dates payload:", working_dates);

  }

  
  return {
    service_id: client.id,
    service_name: client.service_name,
    amount: Number(calculatedAmount).toFixed(2),
    description,
    type: shortType,
    payment_type: paymentType || null,
    start_date: startDate || null,
    end_date: endDate || null,
    start_time: start_time || null,
    end_time: end_time || null,
    hours: hours || 0,
    meeting_type: checkMeetingType || meetingTypeToSend,
    provider_id,
    working_dates
  };
  //  const payload = {
  //   service_id: client.id,
  //   service_name: client.service_name,
  //   amount: Number(calculatedAmount).toFixed(2),
  //   description,
  //   type: shortType,
  //   payment_type: paymentType || null,
  //   start_date: startDate || null,
  //   end_date: endDate || null,
  //   start_time: start_time || null,
  //   end_time: end_time || null,
  //   hours: hours || 0,
  //   meeting_type: checkMeetingType || meetingTypeToSend,
  //   provider_id,
  // };

  // // ✅ Add working_dates only for subscription type
  // if (type === 'subscription') {
  //   payload.working_dates = workingDates;
  // }

  // return payload;
};

 const bookAppointment = async (payload) => {
  console.log("payload", payload);
  // return;

  if (!payload.meeting_type) {
    toast.error("Please enter meeting type", {
      position: "top-right",
      autoClose: 2000,
      style: { fontSize: "0.85rem" },
    });
    return;
  }

  if (!payload.start_date) {
    toast.error("Please enter start date", {
      position: "top-right",
      autoClose: 2000,
      style: { fontSize: "0.85rem" },
    });
    return;
  }
  if (payload.type !== "C") {

    if (payload.type == "H") {
       if (!payload.start_time || payload.start_time === ":00" || payload.start_time === "00:00:00") {
        toast.error("Please enter start time", {
          position: "top-right",
          autoClose: 2000,
          style: { fontSize: "0.85rem" },
        });
        return;
      }
      if (!payload.end_time || payload.end_time === ":00" || payload.end_time === "00:00:00") {
        toast.error("Please enter start time", {
          position: "top-right",
          autoClose: 2000,
          style: { fontSize: "0.85rem" },
        });
        return;
      }
    }
    
    try {
      const res = await fetch(`${process.env.REACT_APP_BACKEND_URL}/client/appointment-checkout-session`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${clientToken}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });

      const data = await res.json();
      const stripe = await stripePromise;

      if (data?.sessionId) {
        await stripe.redirectToCheckout({ sessionId: data.sessionId });
      } else {
        console.error("No session ID received from backend");
      }
    } catch (err) {
      console.error("Stripe Checkout error:", err);
    } 
  } else {

    if (!payload.start_time || payload.start_time === ":00" || payload.start_time === "00:00:00") {
      toast.error("Please enter a valid start time", {
        position: "top-right",
        autoClose: 2000,
        style: { fontSize: "0.85rem" },
      });
      return;
    }

    const appointmentPayload = {
        provider_id: payload.provider_id,
        service_id: payload.service_id,
        start_date: payload.start_date,
        start_time: payload.start_time,
        end_time: payload.end_time,
        type: payload.type,
        meeting_type: payload.meeting_type,
        working_dates: payload.working_dates,
      };
  //     if (payload.working_dates && Array.isArray(payload.working_dates)) {
  //   appointmentPayload.working_dates = payload.working_dates;
  // }
    try {
      const res = await fetch(`${process.env.REACT_APP_BACKEND_URL}/client/book-appointment`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${clientToken}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(appointmentPayload),
      });

      // const data = await res.json();
      toast.success("Appointment Booked", {
              position: "top-right",
              autoClose: 2000,
              style: { fontSize: "0.85rem" },
            });

      navigate("/panel/book_appointment");
    } catch (err) {
      toast.success("Appointment Not booked", {
              position: "top-right",
              autoClose: 2000,
              style: { fontSize: "0.85rem" },
            });
    } 
  }
};

function generateTimeSlots(start: string, end: string) {
  const slots = [];
  const [startH, startM] = start.split(':').map(Number);
  const [endH, endM] = end.split(':').map(Number);

  let current = new Date();
  current.setHours(startH, startM, 0, 0);

  const endTime = new Date();
  endTime.setHours(endH, endM, 0, 0);

  while (current <= endTime) {
    const hours = current.getHours().toString().padStart(2, '0');
    const minutes = current.getMinutes().toString().padStart(2, '0');
    slots.push(`${hours}:${minutes}`);
    current.setMinutes(current.getMinutes() + 30);
  }

  return slots;
}

// Utility: Add duration to time
function calculateEndTime(startTime: string, duration: string) {
  const [startH, startM] = startTime.split(':').map(Number);
  const [durH, durM] = duration.split(':').map(Number);

  const result = new Date();
  result.setHours(startH, startM, 0, 0);
  result.setMinutes(result.getMinutes() + durH * 60 + durM);

  const hours = result.getHours().toString().padStart(2, '0');
  const minutes = result.getMinutes().toString().padStart(2, '0');
  return `${hours}:${minutes}`;
}

function getDayName(dateStr) {
  const days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
  const date = new Date(dateStr);
  return days[date.getDay()];
}

  return (
    <div className="modal-backdrop">
      <div className="modal-box "
      style={
          type === "subscription"
            ? { height: "90%", overflow: "auto", overflowX: "hidden", maxWidth: "600px" }
            : {}
        }>
        <div className="modal-header">
          <button
            type="button"
            className="btn-close"
            onClick={onClose}
            aria-label="Close"
          ></button>
        </div>
        <div className='container'>
          <h2>Book Appointment</h2>

          <div className='form-group'>
            <label>Select Type:</label>
            <br></br>
            {/* <select value={type} onChange={(e) => setType(e.target.value)}  className='form-select'>
              <option value="consult">Consult</option>
              <option value="hourly">Hourly</option>
              <option value="subscription">Subscription</option>
            </select> */}
            <div className="form-check form-check-inline">
              <input
                className="form-check-input"
                type="radio"
                name="type"
                id="type-consult"
                value="consult"
                checked={type === "consult"}
                onChange={(e) => setType(e.target.value)}
              />
              <label className="form-check-label" htmlFor="type-consult">Consult</label>
            </div>

            <div className="form-check form-check-inline">
              <input
                className="form-check-input"
                type="radio"
                name="type"
                id="type-hourly"
                value="hourly"
                checked={type === "hourly"}
                onChange={(e) => setType(e.target.value)}
              />
              <label className="form-check-label" htmlFor="type-hourly">Hourly</label>
            </div>

            <div className="form-check form-check-inline">
              <input
                className="form-check-input"
                type="radio"
                name="type"
                id="type-subscription"
                value="subscription"
                checked={type === "subscription"}
                onChange={(e) => setType(e.target.value)}
              />
              <label className="form-check-label" htmlFor="type-subscription">Subscription</label>
            </div>
          </div>

          <div className='form-group'>
            <h4 className='mt-2'>Consult Appointment</h4>
            <label>Meeting Type:</label><br></br>
            {meetingType.length > 1 ? (
      // Case: both "online" and "offline" available → show both radios
      ["online", "offline"].map((type) => (
        <div className="form-check form-check-inline" key={type}>
          <input
            className="form-check-input"
            type="radio"
            id={`meeting-${type}`}
            name="meetingType"
            value={type}
            checked={checkmeetingType === type}
            onChange={() => setCheckMeetingType(type)} // only one stays selected
          />
          <label className="form-check-label" htmlFor={`meeting-${type}`}>
            {type.charAt(0).toUpperCase() + type.slice(1)}
          </label>
        </div>
      ))
    ) : (
      // Case: only one option → single radio, fixed
      meetingType.map((type) => (
        <div className="form-check form-check-inline" key={type}>
          <input
            className="form-check-input"
            type="radio"
            id={`meeting-${type}`}
            name="meetingType"
            value={type}
            checked
            readOnly
          />
          <label className="form-check-label" htmlFor={`meeting-${type}`}>
            {type.charAt(0).toUpperCase() + type.slice(1)}
          </label>
        </div>
      ))
    )}
    
          </div>

          {/* {type === 'consult' && (
            <div className='form-group'>
              <div className="row">
                <div className="col-6">
                  <label>Date:</label>
                  <input type="date" value={hourlyDate} onChange={(e) => setHourlyDate(e.target.value)} className='form-control'/>
                </div>
                <div className="col-6">
                  <label>Start Time:</label>
                  <input type="time" value={startTime} onChange={(e) => setStartTime(e.target.value)} className='form-control' />
                </div>
              </div>

              <p className='mt-3'><strong>Free Visit</strong></p>
            </div>
          )} */}

{type === 'consult' && (
  <div className='form-group'>
    <div className="row">
      <div className="col-6">
        <label>Date:</label>
        <input 
          type="date" 
          value={hourlyDate} 
          onChange={(e) => setHourlyDate(e.target.value)} 
          className='form-control'
        />
      </div>

      <div className="col-6">
        <label>Start Time:</label>
        {hourlyDate ? (() => {
          const dayName = getDayName(hourlyDate);
          const dayWorkTime = client.provider.worktimes.find(w => w.day === dayName);

          if (!dayWorkTime || dayWorkTime.checked === 'N') {
            return <p className="text-danger mt-2">Closed</p>;
          }

          const availableSlots = generateTimeSlots(dayWorkTime.opening_hours, dayWorkTime.closing_hours);

          return (
            <select
              className="form-select"
              value={startTime}
              onChange={(e) => setStartTime(e.target.value)}
              style={{
                height: "44px"
              }}
            >
              <option value="">Select Start Time</option>
              {availableSlots.map((slot, idx) => (
                <option key={idx} value={slot}>{slot}</option>
              ))}
            </select>
          );
        })() : (
          <p className="text-muted mt-2">Please select a date first</p>
        )}
      </div>
    </div>

    <p className='mt-3'><strong>Free Visit</strong></p>
  </div>
)}



          {/* {type === 'hourly' && (
            <div className='form-group'>
              <h3 className='mt-3'>Hourly Appointment</h3>
              
              <label>Date:</label>
              <input type="date" value={hourlyDate} onChange={(e) => setHourlyDate(e.target.value)} className='form-control'/>
                
              <div class="row">
                <div class="col-6">
                  <label>Start Time:</label>
                  <input type="time" value={startTime} onChange={(e) => setStartTime(e.target.value)} className='form-control' />
                </div>
                <div class="col-6">
                  <label>End Time:</label>
                  <input type="time" value={endTime} 
                  onChange={(e) => setEndTime(e.target.value)} className='form-control' />
                </div>
              </div>
              <p className='mt-3'>Total Charge: <strong>${getHourlyCharge().toFixed(2)}</strong> (@ ${client.amount_per_session}/hour)</p>
            </div>
          )} */}
          {type === 'hourly' && (
  <div className='form-group'>
    <h3 className='mt-3'>Hourly Appointment</h3>

    <label>Date:</label>
    <input
      type="date"
      value={hourlyDate}
      onChange={(e) => setHourlyDate(e.target.value)}
      className='form-control'
    />

    {hourlyDate && (() => {
      const dayName = getDayName(hourlyDate);
      const dayWorkTime = client.provider.worktimes.find(w => w.day === dayName);

      if (!dayWorkTime || dayWorkTime.checked === 'N') {
        return <p className="text-danger mt-2">Closed</p>;
      }

      // Generate time slots if open
      const availableSlots = generateTimeSlots(dayWorkTime.opening_hours, dayWorkTime.closing_hours);

      return (
        <>
          <div className="row mt-3">
            <div className="col-6">
              <label>Start Time:</label>
              <select
                className="form-select"
                value={startTime}
                onChange={(e) => setStartTime(e.target.value)}
              >
                <option value="">Select Start Time</option>
                {availableSlots.map((slot, idx) => (
                  <option key={idx} value={slot}>{slot}</option>
                ))}
              </select>
            </div>
            <div className="col-6">
              <label>End Time:</label>
              <select
                className="form-select"
                value={endTime}
                onChange={(e) => setEndTime(e.target.value)}
              >
                <option value="">Select End Time</option>
                {availableSlots.map((slot, idx) => (
                  <option key={idx} value={slot}>{slot}</option>
                ))}
              </select>
            </div>
          </div>
          <p className='mt-3'>
            Total Charge: <strong>${getHourlyCharge().toFixed(2)}</strong> (@ ${client.amount_per_session}/hour)
          </p>
        </>
      );
    })()}
  </div>
)}


          {type === 'subscription' && (
            Array.isArray(client.provider?.worktimes) && client.provider.worktimes.length > 0 ? (
            <div className='form-group'>
              <h3 className='mt-2'>Subscription Appointment</h3>
              <div className="mb-3 d-flex flex-column">
                <span className="mb-2">
                  <strong>Plan Duration:</strong> {durationInDays} Days
                </span>
                <span>
                  <strong>Daily Hours:</strong> {client.daily_hours}
                </span>
              </div>
              <div class="row mt-2">
                <div class="col-6">
                  <label>Start Date:</label>
                  <input type="date" value={subscriptionStartDate} onChange={(e) => setSubscriptionStartDate(e.target.value)} className='form-control' />
                </div>
                <div class="col-6">
                  <label>End Date:</label>
                  <input type="date" value={subscriptionEndDate} className='form-control' />
                </div>
              </div>
              {/* <div class="row">
                <div class="col-6">
                  <label className='mt-2'>Daily Start Time:</label>
                  <input type="time" value={subscriptionStartTime} onChange={(e) => setSubscriptionStartTime(e.target.value)} className='form-control' />
                </div>
                <div class="col-6">
                  <label className='mt-2'>Daily End Time:</label>
                  <input type="time" value={subscriptionEndTime} className='form-control' />
                </div>
              </div> */}
            <div className="row mt-3">
              {client.provider?.worktimes?.map((dayObj, index) => {
                const isEnabled = dayObj.checked === 'Y';
                const timeSlots = isEnabled
                  ? generateTimeSlots(dayObj.opening_hours, dayObj.closing_hours)
                  : [];

                const selectedStart = selectedTimes[index]?.start || '';
                const selectedEnd = selectedTimes[index]?.end || '';

                return (
                  <div className="col-md-6 mb-3" key={index}>
                    <label className="fw-bold">{dayObj.day}</label>

                    {isEnabled ? (
                      <div className="d-flex gap-2">
                        <select
                          className="form-select"
                          value={selectedStart}
                          onChange={(e) => handleStartChange(index, e.target.value)}
                        >
                          <option value="" disabled>
                            Start Time
                          </option>
                          {timeSlots.map((time, idx) => (
                            <option key={idx} value={time}>
                              {time}
                            </option>
                          ))}
                        </select>

                        <input
                          type="text"
                          className="form-control"
                          value={selectedEnd}
                          placeholder="End Time"
                          readOnly
                        />
                      </div>
                    ) : (
                      <div style={{ color: 'red', fontWeight: 'bold', marginTop: '0.5rem' }}>
                        Closed
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
              <div class="row">
                {/* <div class="col-6"> */}
                  {/* <label className='mt-2'>Number of Days:</label> */}
                  <input type="hidden" value={durationInDays} className='form-control' disabled />
                {/* </div> */}
                <div class="col-6">
                  <label className='mt-2'>Payment Type:</label>
                  <select
                    className='form-select'
                    value={paymentType}
                    onChange={(e) => setPaymentType(e.target.value)}
                  >
                    <option value="monthly">Monthly (${client.amount})</option>
                    <option value="weekly">Weekly (${client.charge_per_week})</option>
                  </select>
                </div>
                <div className="col-6">
                  <label className="mt-2">Total Charge:</label>
                  <div className="mt-1 fw-bold">
                    ${paymentType === 'weekly' 
                      ? parseFloat(client.charge_per_week).toFixed(2) 
                      : parseFloat(client.amount).toFixed(2)}
                  </div>
                </div>
              </div>
              

            </div>
             ) : (
    <div className="alert alert-warning mt-3">
      No booking available for this service.
    </div>
  )
          )}

          <button
  className='btn btn-custom-primary mt-3'
  onClick={() => {
    const payload = prepareBookingPayload();
    if (payload) {
      bookAppointment(payload);
    }
  }}
  disabled={
    !Array.isArray(client.provider?.worktimes) || 
    client.provider.worktimes.length === 0 || 
    !client.provider.worktimes.some(day => day.checked === 'Y')
  }
>
  Confirm Booking
</button>

          <button type="button" className="btn btn-secondary ms-3 mt-3" onClick={onClose}>Cancel</button>
        </div>
      </div>
    </div>
  );
};

export default BookAppointmentModal;
